import { render, staticRenderFns } from "./OrderModActionModal.vue?vue&type=template&id=323b08c4&"
import script from "./OrderModActionModal.vue?vue&type=script&lang=js&"
export * from "./OrderModActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports